import React from 'react';
import { motion } from 'framer-motion';
interface ArticlePageProps {
  /** Printed page number shown in the folio. */
  folio: number;
  /** Running head printed opposite the folio number. */
  runningHead: string;
  /** Dark pages invert the sheet, the way a magazine runs a photo section. */
  tone?: 'paper' | 'ink';
  /** Removes the inner gutters so a photo can run to the trim edge. */
  bleed?: boolean;
  children: React.ReactNode;
}

/**
 * One sheet of the printed feature. Pages are separated by the dark gutter
 * behind them and each carries a folio, so the article reads as a sequence of
 * spreads rather than one endless scroll.
 */
export function ArticlePage({
  folio,
  runningHead,
  tone = 'paper',
  bleed = false,
  children
}: ArticlePageProps) {
  const ink = tone === 'ink';
  // Verso pages carry the number on the left, recto on the right, as in print.
  const verso = folio % 2 === 0;
  return <motion.section initial={{
    opacity: 0,
    y: 14
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }} className={`relative mx-auto w-full max-w-[1180px] shadow-[0_24px_70px_rgba(0,0,0,0.55)] ${ink ? 'bg-[#171310] text-[#f5f1e8]' : 'bg-[#f5f1e8] text-[#171310]'}`} data-id="element-882" data-mp="1ulbeatz3bbf2">
      <div className={bleed ? '' : 'px-6 pt-14 sm:px-12 lg:px-16 lg:pt-20'} data-id="element-883" data-mp="1w4vchcju8rql">{children}</div>

      <footer className={`mt-10 flex items-center gap-4 px-6 pb-7 pt-4 sm:px-12 lg:px-16 ${verso ? 'flex-row' : 'flex-row-reverse'} ${ink ? 'border-t border-[#f5f1e8]/12' : 'border-t border-[#171310]/12'}`} data-id="element-884" data-mp="18f0z8tvlx15t">
        <span className={`font-serif-display text-[17px] leading-none tabular-nums ${ink ? 'text-[#d98b4a]' : 'text-[#9c4a1a]'}`} data-id="element-885" data-mp="1i5lvwbrpzvm3">
          {folio}
        </span>
        <span className={`text-[9.5px] font-medium uppercase tracking-[0.24em] ${ink ? 'text-[#f5f1e8]/35' : 'text-[#171310]/35'}`} data-id="element-886" data-mp="pl59zxoskqkx">
          {runningHead}
        </span>
      </footer>
    </motion.section>;
}